import CommissionSlider from './CommissionSlider';
import CommissionSliderContainer from './CommissionSlider.container';

export default CommissionSliderContainer(CommissionSlider);
